export const EVENT_STATUS_DRAFT = 'draft';
export const EVENT_STATUS_PAST = 'past';
export const EVENT_STATUS_CANCELED = 'canceled';

export const USED_AS_SAVE_THE_DATE = 'save_the_date';
export const USED_AS_CARD = 'card';
export const USED_AS_GIFT_CARD = 'gift_card';
